import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

const state = {
    orderNo: '',
    token: '',
    type: '',
}
const mutations = {
    changeState(store) {
        //点击聊天
        // store.BusinessCardisShow = false;
        // store.navnumber = 1;
    },
}
const actions = {

}
const getters = {

}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/vuex/store.js